module.exports = __webpack_public_path__ + "static/trailer-897e4c875fe126db3cc74e9560c37621.webm";